import { Outlet } from 'react-router-dom';
import PromoStrip from '@/components/shop/PromoStrip';
import RunningBanner from '@/components/shop/RunningBanner';
import Header from '@/components/shop/Header';
import BottomNav from '@/components/shop/BottomNav';
import Footer from '@/components/shop/Footer';
import WhatsAppFAB from '@/components/shop/WhatsAppFAB';
import CartDrawer from '@/components/shop/CartDrawer';
import ScrollToTop from '@/components/shop/ScrollToTop';
import AnalyticsLoader from '@/components/shop/AnalyticsLoader';
import ThemeApplier from '@/components/shop/ThemeApplier';

export default function CustomerLayout() {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--app-bg, #F1F8E9)' }}>
      <ThemeApplier />
      <AnalyticsLoader />
      <RunningBanner />
      <PromoStrip />
      <Header />
      <main className="flex-1 pb-20 md:pb-0">
        <Outlet />
      </main>
      <Footer />
      <BottomNav />
      <WhatsAppFAB />
      <ScrollToTop />
      <CartDrawer />
    </div>
  );
}
